module.exports = __webpack_public_path__ + "static/media/light-motion-adcs-design.a341937.mp4";